const PropTypes = require('prop-types');
const React = require('react');
const { HashUtil } = require('@reverbdotcom/discovery-ui');

class UserBadge extends React.Component {
  getLink() {
    return HashUtil.getSafely(this.props, 'countRecord._links.web.href');
  }

  hasCount() {
    return this.props.countRecord.count > 0 || this.props.persist;
  }

  hasDisplayText() {
    return !!this.props.countRecord.display_text;
  }

  shouldDisplay() {
    return this.hasCount() && this.hasDisplayText();
  }

  render() {
    if (this.shouldDisplay()) {
      return (
        <li>
          <a
            className="site-header__menu__link"
            href={this.getLink()}
            rel={this.props.rel}
            data-notification-count={this.props.countRecord.count}
          >
            {this.props.countRecord.display_text}
          </a>
        </li>
      );
    }

    return null;
  }
}

UserBadge.propTypes = {
  countRecord: PropTypes.object.isRequired,
  rel: PropTypes.string.isRequired,
  persist: PropTypes.bool,
};

UserBadge.defaultProps = {
  countRecord: {},
};

module.exports = UserBadge;



// WEBPACK FOOTER //
// ./javascripts/components/user_badge.jsx